import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精选优质影视内容推荐，观影指南、深度解读与行业观察
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardsData.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-accent-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-[200px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-base font-medium text-foreground-800 mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}